import { OffTargetAssignmentCtrl } from './off-target-assignment.controller';

export const OffTargetAssignmentComponent = {
  controller: OffTargetAssignmentCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./off-target-assignment.html'),
};
